import { Link } from "gatsby";
import React from "react";
import navigationItems from "./NavigationItems";

const SiteMap = () => {
  return (
    <nav className="my-2 pb-4">
      <Link to="/impressum" activeClassName="active-item" className="pe-4">
        Impressum
      </Link>
      <Link to="/datenschutz" activeClassName="active-item" className="pe-4">
        Datenschutz
      </Link>
      {navigationItems.map((navItem, idx) => (
        <Link
          key={idx}
          to={navItem.url}
          activeClassName="active-item"
          className="pe-4"
        >
          {navItem.page}
        </Link>
      ))}
    </nav>
  );
};

export default SiteMap;
